import * as React from 'react';
import { observer } from 'mobx-react';

const styles = require('./index.less');

const TeamGuestView = ({ store }) => {
  const viewModel = store.teamGuestViewModel;
  const handlePrimaryAction = () => {
    if (viewModel.primaryAction === 'join') {
      return store.handleGuestJoin();
    }
    if (viewModel.primaryAction === 'create') {
      return store.handleGuestCreate();
    }
    if (viewModel.primaryAction === 'invite') {
      return store.copyTeamInvite();
    }
    return false;
  };

  return (
    <main className={styles.root} data-name="team-guest-view" data-state={viewModel.state}>
      <a className={styles.logo} href="https://jxsj.xoyo.com/" target="_blank" rel="noopener noreferrer">
        <span>剑侠世界端游官网</span>
      </a>
      <nav className={styles.navigation} aria-label="客态页导航">
        <a href="https://jxsj.xoyo.com/" target="_blank" rel="noopener noreferrer" onClick={() => store.onOfficialSiteClick()}>
          <span>进入官网</span>
        </a>
        <button type="button" onClick={() => store.onFeatureTopicClick()} aria-label="资料片专题" />
      </nav>
      <strong className={styles.subtitleServerName}>{viewModel.serverName}</strong>
      <p className={styles.introductionText}>
        我已预约《剑侠世界》首个生态服【<span>{viewModel.serverName}</span>】快和我组队购买钜惠礼包，一起玩新服，这波福利不能错过！
      </p>
      {/* 与主态页共用登录状态及认证操作，避免客态维护独立登录态。 */}
      <div className={styles.accountStatus} aria-label="账号登录状态">
        {!store.loginStore.isReady ? null : store.loginStore.isLogin ? (
          <React.Fragment>
            {store.loginStore.userName}，
            <button type="button" onClick={store.loginStore.logout}>
              【退出】
            </button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            你好，请
            <button type="button" onClick={store.loginStore.signIn}>
              【登录】
            </button>
          </React.Fragment>
        )}
      </div>
      <section className={styles.giftPanel} aria-label="钜惠组队礼包" />
      <div className={styles.actions} data-state={viewModel.state}>
        {viewModel.showPrimary && (
          <button className={styles.primaryAction} type="button" disabled={!viewModel.canPrimaryAction} onClick={handlePrimaryAction}>
            <span>{viewModel.primaryLabel}</span>
          </button>
        )}
        {viewModel.showCreate && (
          <button className={styles.createAction} type="button" onClick={() => store.handleGuestCreate()}>
            <span>创建购买队伍</span>
          </button>
        )}
        <button className={styles.reserveAction} type="button" onClick={() => store.handleGuestReserveAction()}>
          <span>{viewModel.reserveLabel}</span>
        </button>
      </div>
    </main>
  );
};

export default observer(TeamGuestView);
